var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuestionMarkLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 25,
    fill: "#1B2B41",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.6805 27.8516V27.4297C23.6805 26.8203 23.7743 26.3203 23.9618 25.9297C24.1493 25.5339 24.4982 25.1172 25.0086 24.6797C25.717 24.0807 26.1623 23.6302 26.3446 23.3281C26.5321 23.026 26.6258 22.6615 26.6258 22.2344C26.6258 21.7031 26.4539 21.2943 26.1102 21.0078C25.7717 20.7161 25.2821 20.5703 24.6414 20.5703C24.23 20.5703 23.8289 20.6198 23.4383 20.7188C23.0477 20.8125 22.5998 20.987 22.0946 21.2422L21.6336 20.1875C22.618 19.6719 23.6467 19.4141 24.7196 19.4141C25.7144 19.4141 26.4878 19.6589 27.0399 20.1484C27.592 20.638 27.868 21.3281 27.868 22.2188C27.868 22.599 27.8159 22.9349 27.7118 23.2266C27.6128 23.513 27.4644 23.7865 27.2664 24.0469C27.0685 24.3021 26.6414 24.7161 25.9852 25.2891C25.4592 25.737 25.1102 26.1094 24.9383 26.4062C24.7717 26.7031 24.6883 27.099 24.6883 27.5938V27.8516H23.6805ZM23.2977 30.1719C23.2977 29.4635 23.6102 29.1094 24.2352 29.1094C24.5373 29.1094 24.7691 29.2005 24.9305 29.3828C25.0972 29.5651 25.1805 29.8281 25.1805 30.1719C25.1805 30.5052 25.0972 30.7656 24.9305 30.9531C24.7638 31.1354 24.5321 31.2266 24.2352 31.2266C23.9644 31.2266 23.7404 31.1458 23.5633 30.9844C23.3862 30.8177 23.2977 30.5469 23.2977 30.1719Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMarkLight);
export default __webpack_public_path__ + "static/media/question-mark-light.e60a9f0016fd73555dc7e43b4e5ebc4b.svg";
export { ForwardRef as ReactComponent };